import React,{useState}from'react';
import PersonHeader from './PersonHeader';

const parseAvailability=value=>{
  const text=String(value??'').trim();
  if(!text||/n\/a|—|--/i.test(text))return null;
  const full=text.match(/(\d+)\s*(?:Full|F)\b/i);
  const partial=text.match(/(\d+)\s*(?:Partial|P)\b/i);
  if(full)return{full:Number(full[1]),partial:partial?Number(partial[1]):0};
  const n=Number(text);
  return Number.isFinite(n)?{full:n,partial:0}:null;
};

const backfillClass=value=>{
  const counts=parseAvailability(value);
  if(!counts)return'pub-neutral';
  if(counts.full===0&&counts.partial>0)return'pub-warn';
  if(counts.full===0)return'pub-bad';
  if(counts.full<=3)return'pub-warn';
  return'pub-good';
};

const resultClass=value=>{
  const text=String(value||'');
  if(/Partial Backfill Only/i.test(text))return'pub-warn';
  if(/No Backfill|No Candidates/i.test(text))return'pub-bad';
  if(/Backfill Candidates Available|Available/i.test(text))return'pub-good';
  return'pub-neutral';
};

function ExtensionSummary({summary}){
  const s=summary||{};
  return <div className="pub-summary">
    <div className="pub-box"><span>Normal Shift</span><strong className="shift">{s.normalShift||'—'}</strong></div>
    <div className="pub-box"><span>Normal Duty Periods</span><strong>{s.normalDutyPeriods||0}</strong></div>
    <div className="pub-box"><span>Periods w/ Backfill</span><strong>{s.periodsWithBackfill||0}</strong></div>
    <div className="pub-box"><span>Periods w/o Backfill</span><strong>{s.periodsWithoutBackfill||0}</strong></div>
  </div>;
}

function ExtensionTable({rows}){
  if(!rows?.length)return <div className="pub-note">No normal duty periods are affected in the loaded 7-day window.</div>;
  return <div className="pub-table-wrap"><table className="pub-table"><thead><tr>
    <th>Normal Duty Date</th><th>Rank</th><th>Full-Day Backfill</th><th>Candidate Names</th><th>Extension Impact</th>
  </tr></thead><tbody>
    {rows.map((r,i)=><tr key={i}>
      <td>{r.dateDisplay||r.date}</td>
      <td>{r.neededRank||'—'}</td>
      <td className={backfillClass(r.backfillCandidates)}>{r.backfillCandidates}</td>
      <td className="left">{r.candidateNames||'—'}</td>
      <td className={resultClass(r.result)}>{r.result}</td>
    </tr>)}
  </tbody></table></div>;
}

export default function DeployedPerson({person}){
  const[open,setOpen]=useState(false),[data,setData]=useState(null),[loading,setLoading]=useState(false),[error,setError]=useState('');
  const toggle=async()=>{
    if(open){setOpen(false);return;}
    setOpen(true);if(data)return;setLoading(true);setError('');
    try{
      const r=await fetch(`/api/line-medic?mode=extension&name=${encodeURIComponent(person.name)}`,{cache:'no-store'});
      const j=await r.json();
      if(!r.ok||j.error)throw new Error(j.error||'Unable to load extension review.');
      setData(j);
    }catch(e){setError(e?.message||String(e));}finally{setLoading(false);}
  };
  const button=<button className="pub-btn" onClick={toggle}>{open?'Hide Extension / Reassignment Review':'Extension / Reassignment Review'}</button>;
  return <div className="pub-person"><PersonHeader person={person} button={button}/>{open&&<div className="pub-panel">
    <div className="pub-note"><strong>Extension / Reassignment Staffing Review</strong><br/>Shows only this member&apos;s normal scheduled duty days and uses Full-Day (A24) backfill candidates only on every day, including Day 1. Partial Picklists do not count for extension/reassignment review. Callback, mandatory callback, trades, swaps, overtime assignments, and off days are excluded.</div>
    {loading&&<div className="pub-note">Loading extension / reassignment review…</div>}
    {error&&<div className="pub-error">{error}</div>}
    {data&&<><ExtensionSummary summary={data.summary}/><div className="pub-decision">{data.summaryResult}</div><ExtensionTable rows={data.rows}/></>}
  </div>}</div>;
}
